export class SearchDBResponse {
    'data';
    'pagination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "data",
            "baseName": "data",
            "type": "Array<UnifiedDBRecord>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SearchDBResponse.attributeTypeMap;
    }
    constructor() {
    }
}
